<template>
  <CustomModal ref="modal" title="Association dossier">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <CustomSelectField ref="statusSelect" :content=inputs.order />
        <CustomButton @click="submitForm" :params=buttons.submit style="margin-top: 15px" />
        <div class="separator"></div>
        <CustomButton @click="autoCreate" :params=buttons.autoCreate style="margin-top: 15px" />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {ProductionController} from "@/controllers/production/ProductionController";
import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";

  export default {
      name: 'EditCommandNumberModal',
      props: ['callback'],
      components: {
        CustomSelectField,
         CustomModal, CustomForm, CustomButton
      },
      data() {
          return {
            business: undefined,
            inputs: {
              order: {label: 'Dossier', value: '', type: 'select', selectValues: [], required: true},
            },
            buttons:{
              submit: {text: "Valider"},
              autoCreate: {text: "Créer à partir de ce devis"},
            },
            isTerminateButtonDisplayed: false
          };
      },
      methods: {
        async openModal(business) {
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.business = business;
          await this.fillSelect();
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(){
          this.closeModal();
          this.callback(true);
        },
        async fillSelect() {
          this.inputs.order.selectValues = [];
          let resp = await this.$refs.form.submitForm(() => ProductionController.getNumbers());
          if(!resp.errors){
             resp.sort((a, b) => b.number - a.number);
            for(let i=0; i < resp.length ;i++){
              this.inputs.order.selectValues.push({label: this.formatOrderLabel(resp[i]), value: resp[i].number});
            }
          }
        },
        formatOrderLabel(order){
          return "N°" + order.number + " - " + (order.title ? order.title : "__________________________");
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => BusinessController.patch(this.business.id,{
            orderNumber: this.inputs.order.value,
          }));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Numéro de dossier modifié");
            this.terminate();
          }
        },
        async autoCreate() {
          const res = await this.$refs.form.submitForm(() => BusinessController.createOrder(this.business.id));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Dossier créé");
            this.terminate();
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    .separator
      margin-top 15px
      height 2px
      background-color THEME_COLOR_PRIMARY_FADDED
      opacity 0.6
</style>
